<router-outlet (activate)="scrollToTop()"></router-outlet>

<app-keyboard class="global-keyboard"></app-keyboard>

<app-loader
	#applicationloader
	[isActive]="false"
	[context]="LoaderContext.global"
></app-loader>
<app-loader
	#pageLoader
	[isActive]="false"
	[context]="LoaderContext.page"
></app-loader>

@if (isDevelop) {
	<app-dev-tools></app-dev-tools>
}

<app-version
	[frontendVersion]="frontendVersion"
	[frontendBranchName]="frontendBranchName"
	[packageVersion]="packageVersion"
></app-version>
